var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"black-container"},[_c('dv-loading',{staticStyle:{"position":"absolute","left":"0","right":"0","color":"#ffff"}},[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }